import * as segment from 'main/util/analytics/segment'
import { UnreachableCaseError } from 'main/util/ts'

import { User } from '../../types'
import { IStep, ITrackData, StepType } from './types'

export function buildStep(stepType: StepType, instantEnroll: boolean, user?: User | null): IStep {
  const current: Pick<IStep, 'current'> = { current: stepType }

  switch (stepType) {
    case StepType.INIT:
      return {
        ...current,
        next: instantEnroll && user ? StepType.PAYMENT_METHOD : user ? null : StepType.SIGN_UP,
      }
    case StepType.LOGIN:
      return { ...current, next: instantEnroll ? StepType.PAYMENT_METHOD : null }
    case StepType.SIGN_UP:
      return { ...current, next: instantEnroll ? StepType.PAYMENT_METHOD : null }
    case StepType.PAYMENT_METHOD:
      return { ...current, next: null }
    default:
      throw new UnreachableCaseError(stepType)
  }
}

export function track(step: StepType, data: ITrackData) {
  const event: string = `Instant Enroll: ${step}_completed`
  segment.track(event, data)
}
